/**
 * useCities — Übersicht der Top-Städte (öffentliche Landeseite /cities).
 */
import { useApi } from '../../lib/use-api'
import { fetchCities, type CityListResponse } from './citiesApi'

type UseCitiesResult = {
  data: CityListResponse | undefined
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

export function useCities(params: { sort?: string; order?: string; page?: number } = {}): UseCitiesResult {
  const query = useApi<CityListResponse>(['cities', params], async () => {
    const result = await fetchCities(params)
    return result as { data?: CityListResponse; error?: unknown }
  })

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => query.refetch(),
  }
}
